export type GroupableContact = {
  role?: string | null;
  is_staff?: boolean | null;
};

export type GroupedContacts<T> = {
  consultants: T[];
  inspectors: T[];
  siteContacts: T[];
};

// Mirrors the hub SiteDetailContent grouping: the consultant card reads roles
// 'contractor' (legacy storage) and 'consultant'; inspectors get their own
// group; everything else (owner / manager / unknown) is a site contact.
export function groupContactsByRole<T extends GroupableContact>(
  contacts: T[]
): GroupedContacts<T> {
  const consultants: T[] = [];
  const inspectors: T[] = [];
  const siteContacts: T[] = [];
  for (const contact of contacts) {
    const role = (contact.role ?? '').trim().toLowerCase();
    // JIM-1007-05: a client-side contractor is a site contact, not the consultant.
    if (
      role === 'consultant' ||
      (role === 'contractor' && contact.is_staff === true)
    ) {
      consultants.push(contact);
    } else if (role === 'inspector') {
      inspectors.push(contact);
    } else {
      siteContacts.push(contact);
    }
  }
  return { consultants, inspectors, siteContacts };
}
